module.exports = __webpack_public_path__ + "static/error-image-f32b25942edba3c283fae23f841f4cca.svg";